.authenticationForm {
  display: flex;
  flex-direction: column;
  width: 100%;

  &.flat {
    .title {
      margin: 0.125rem 0 0.375rem;
      padding: 0 2.875rem 0 0;
      line-height: 2.75rem;
      text-align: left;
    }

    .divider {
      order: 3;
      margin: 0.625rem 0 0;

      .dividerText {
        margin-top: 0.875rem;
        margin-bottom: 0.875rem;
      }
    }

    .links {
      justify-content: flex-start;
      margin: 0 0 1.5rem;

      @media (min-width: 400px) {
        margin: 0 0 1.875rem;
      }
    }

    .providers {
      order: 2;
    }

    .form {
      order: 4;
    }
  }

  .title {
    margin: 0 auto 2.5rem;
    padding: 0 1.5rem;
    text-align: center;

    @media (min-width: 400px) {
      margin-bottom: 2.5625rem;
    }
  }

  .divider {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.375rem;

    &:before,
    &:after {
      width: calc(50% - 2.25rem);
      min-height: 0.0625rem;
      content: '';
      background-color: var(--neutral-200);
    }

    .dividerText {
      margin: 1.5rem 0 1.375rem;

      @media (min-width: 400px) {
        margin: 1.75rem 0 1.625rem;
      }
    }
  }

  .links {
    display: flex;
    align-items: center;
    margin: 1.5625rem 0 1rem;

    .link {
      height: 1.6875rem;
      margin-left: 0.3125rem;
    }
  }
}
